module.exports = __webpack_public_path__ + "static/media/warner-music-logo.6a6d4332.svg";